import {
  isOfflineAndroid,
  createRequestId,
  ensureCallbackRegistry
} from './androidOfflineCart';


const markOfflineOrderPaid = (localOrderId) => {

  return new Promise((resolve, reject) => {

    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS
        .markOfflineOrderPaidCash !==
      'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.markOfflineOrderPaidCash is not available'
        )
      );
      return;
    }

    if (!localOrderId) {
      reject(
        new Error(
          'localOrderId is required'
        )
      );
      return;
    }

    const requestId =
      createRequestId(
        'mark_offline_order_paid'
      );

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[
      requestId
    ] = {
      resolve,
      reject
    };

    console.log(
      '[OFFLINE_PAYMENT] Calling Android bridge',
      {
        requestId,
        localOrderId
      }
    );

    try {

      window.AndroidPOS.markOfflineOrderPaidCash(
        requestId,
        String(localOrderId)
      );

    } catch (error) {

      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);

      return;
    }

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[
          requestId
        ]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        console.error(
          '[OFFLINE_PAYMENT] Bridge timeout',
          {
            requestId,
            localOrderId
          }
        );

        reject(
          new Error(
            `Offline payment timeout: ${requestId}`
          )
        );
      }

    }, 10000);
  });
};

const markOfflineTablePaid = (tableId) => {

  return new Promise((resolve, reject) => {

    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS
        .markOfflineTablePaidCash !==
      'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.markOfflineTablePaidCash is not available'
        )
      );
      return;
    }

    if (
      tableId === null ||
      tableId === undefined ||
      String(tableId).trim() === ''
    ) {
      reject(
        new Error(
          'tableId is required'
        )
      );
      return;
    }

    const requestId =
      createRequestId(
        'mark_offline_table_paid'
      );

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[
      requestId
    ] = {
      resolve,
      reject
    };

    console.log(
      '[OFFLINE_TABLE_PAYMENT] Calling Android bridge',
      {
        requestId,
        tableId
      }
    );

    try {

      window.AndroidPOS.markOfflineTablePaidCash(
        requestId,
        String(tableId)
      );

    } catch (error) {

      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);

      return;
    }

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[
          requestId
        ]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        console.error(
          '[OFFLINE_TABLE_PAYMENT] Bridge timeout',
          {
            requestId,
            tableId
          }
        );

        reject(
          new Error(
            `Offline table payment timeout: ${requestId}`
          )
        );
      }

    }, 10000);
  });
};

export {
  markOfflineOrderPaid,
  markOfflineTablePaid
};